/**
 * BlogARSiteHeaderLanguagesView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait BlogARSiteHeaderLanguages
 */

import { useBlogARSiteHeaderLanguagesLogic } from '@/hooks/traits/useBlogARSiteHeaderLanguagesLogic';
import type { BlogARSiteHeaderLanguagesConfig } from '@/hooks/traits/useBlogARSiteHeaderLanguagesLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { BlogARBlogView as BlogARBlogViewEntity } from '@app/shared';
import { Button } from '@almadar/ui/components';
import { Menu } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';
import { useTranslate } from '@almadar/ui/hooks';

interface BlogARSiteHeaderLanguagesViewProps {
  config?: Partial<BlogARSiteHeaderLanguagesConfig>;
}

export function BlogARSiteHeaderLanguagesView({ config: propsConfig }: BlogARSiteHeaderLanguagesViewProps) {
  const { t: __t, locale: __locale } = useTranslate();
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useBlogARSiteHeaderLanguagesLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['BlogARBlogView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="BlogAR" trait="BlogARSiteHeaderLanguages">
      {slotWriter['main'] === 'INIT' ? (<Menu className={((([{ code: "en" as const, label: "English" as const, href: "/blog" as const }, { href: "/ar/blog" as const, label: "العربية" as const, code: "ar" as const }, { href: "/sl/blog" as const, code: "sl" as const, label: "Slovenščina" as const }]).length === 0)) ? "hidden" : ""} trigger={<Button size="sm" icon="globe" label={String(__locale.toUpperCase())} variant="ghost" />} items={Array.isArray(([{ label: "English" as const, href: "/blog" as const, code: "en" as const }, { label: "العربية" as const, code: "ar" as const, href: "/ar/blog" as const }, { href: "/sl/blog" as const, code: "sl" as const, label: "Slovenščina" as const }]).map((entry) => ({ href: (getNestedValue(entry, "href") ?? ""), label: (getNestedValue(entry, "label") ?? ""), id: (getNestedValue(entry, "code") ?? ""), icon: (((getNestedValue(entry, "code") ?? "") === __locale) ? "check" : "") }))) ? (((([{ label: "English" as const, href: "/blog" as const, code: "en" as const }, { label: "العربية" as const, code: "ar" as const, href: "/ar/blog" as const }, { href: "/sl/blog" as const, code: "sl" as const, label: "Slovenščina" as const }]).map((entry) => ({ href: (getNestedValue(entry, "href") ?? ""), label: (getNestedValue(entry, "label") ?? ""), id: (getNestedValue(entry, "code") ?? ""), icon: (((getNestedValue(entry, "code") ?? "") === __locale) ? "check" : "") }))) as EntityRow[]) as ({ badge?: string | number; disabled?: boolean; event?: string; href?: string; icon?: string; id?: string; label: string; onClick?: never; subMenu?: never[]; title?: string; type?: 'item' | 'divider'; url?: string; variant?: 'default' | 'danger' })[]) : []} position="bottom-end" />) : null}
    </TraitScopeProvider>
  );
}

export default BlogARSiteHeaderLanguagesView;
